import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import {
  getItemWhseChg,
  validateOrderType,
  validateCorePendDateRetail,
  validateDirectReplenFlag,
  updateItemWhse
} from "../../../actions";
import Sanckbar from "../../common/Sanckbar";
import StatusModal from "../../common/StatusModal";
import Spinner from "../../common/Spinner";
import Tooltip from "../../common/Tooltip";
import BottomLayout from "./BottomLayout";
import { Link } from "react-router-dom";

class ItemInformationByDc extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (this.state.lookup && this.state.lookup.item && this.state.lookup.wse) {
      var item = parseInt(this.state.lookup.item, 10).toString();
      getItemWhseChg(item, this.state.lookup.wse).then(res => {
        msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
        if (res.data.success) {
          const data = res.data.data;
          // const whsesForItem = res.data.data.whsesForItem;
          // delete data.whsesForItem;
          this.setState({ data });
          this.setState({
            header: [
              {
                label: "Item",
                value: this.numberToZeroPadded(res.data.data.itemNumber, 9),
                name: "itemNumber"
              },
              {
                label: "Description",
                value: res.data.data.description,
                name: "description"
              },
              {
                label: "Line",
                value: res.data.data.lineCode,
                name: "lineCode"
              },
              {
                label: "Part",
                value: res.data.data.partNumber,
                name: "partNumber"
              },
              {
                label: "Warehouses",
                //value: whsesForItem,
                name: "wse"
              },
              {
                label: "Model Item",
                value: 0,
                name: "modelItem"
              },
              {
                label: "Model Warehouse",
                value: 0,
                name: "modelWarehouse"
              },
              {
                label: "Average Cost",
                value: res.data.data.currentCostBase,
                name: "currentCostBase"
              },
              {
                label: "Average Core",
                value: res.data.data.currentCostCore,
                name: "currentCostCore"
              },
              {
                label: "LIFO Pool",
                value: res.data.data.lifoPool,
                name: "lifoPool"
              },
              {
                label: "LIFO Cost",
                value: res.data.data.lifoCost,
                name: "lifoCost"
              },
              {
                label: "Net NIPO + Core",
                value: res.data.data.netNipoCore,
                name: "netNipoCore"
              },
              {
                label: "Sub Item",
                value: res.data.data.subItem,
                name: "subItem"
              },
              {
                label: "Sub Type",
                value: res.data.data.subType,
                name: "subType"
              },
              {
                label: "Item Status",
                value: res.data.data.itemStatus,
                name: "itemStatus"
              },
              {
                label: "Date",
                value: res.data.data.itemStatusDate,
                name: "itemStatusDate"
              },
              {
                label: "Core Retail",
                value: res.data.data.coreRetail,
                name: "coreRetail"
              },
              {
                label: "Pending Core Retail^",
                value: res.data.data.corePendRetail,
                name: "corePendRetail"
              },
              {
                label: "Pending Date",
                value: res.data.data.corePendDate,
                name: "corePendDate"
              }
            ],
            cards: [
              //cards
              {
                card1: [
                  {
                    label: "In-And-Out Item Flag",
                    value: res.data.data.inOutFlag,
                    name: "inOutFlag"
                  },
                  {
                    label: "Order Type",
                    value: res.data.data.orderType,
                    name: "orderType"
                  },
                  {
                    label: "EOQ Cost",
                    value: res.data.data.fixedOrderCost,
                    name: "fixedOrderCost"
                  },
                  {
                    label: "Warehouse EOQ Logic",
                    value: res.data.data.whseEoqFlag,
                    name: "whseEoqFlag"
                  },
                  {
                    label: "Reserve Inventory",
                    value: res.data.data.reserveInventory,
                    name: "reserveInventory"
                  },
                  {
                    label: "Direct Replenishment Flag",
                    value: res.data.data.directReplenFlag,
                    name: "directReplenFlag"
                  },
                  {
                    label: "Store Order Minimum",
                    value: res.data.data.storeOrderMin,
                    name: "storeOrderMin"
                  },
                  {
                    label: "Inventory Action Code",
                    value: res.data.data.invActionCode,
                    name: "invActionCode"
                  },
                  {
                    label: "Store Order Maximum",
                    value: res.data.data.storeOrderMax,
                    name: "storeOrderMax"
                  }
                ]
              },
              {
                card2: [
                  {
                    span: "^Enter .01 to Reset Core Retail to Zeros",
                    value: "",
                    name: "na"
                  }
                ]
              },
              {
                card3: [
                  {
                    label: "Slot",
                    value: res.data.data.lineSlot,
                    name: "lineSlot"
                  },
                  {
                    label: "Reserve On Order",
                    value: res.data.data.onOrderReserve,
                    name: "onOrderReserve"
                  },
                  {
                    label: "Recall Expected",
                    value: res.data.data.recallQtyExpect,
                    name: "recallQtyExpect"
                  },
                  {
                    label: "In Stock",
                    value: res.data.data.inStock,
                    name: "inStock"
                  },
                  {
                    label: "VDP Invoice Bal*",
                    value: res.data.data.vendInvBal,
                    name: "vendInvBal"
                  },
                  {
                    label: "Setup Date",
                    value: res.data.data.setupDate,
                    name: "setupDate"
                  },
                  {
                    label: "On Order",
                    value: res.data.data.onOrderRegular,
                    name: "onOrderRegular"
                  },
                  {
                    span: `* Warehouse ${res.data.data.whseIntl} Only`,
                    name: "whseIntl"
                  },
                  {
                    label: "Change Date",
                    value: res.data.data.changeDate,
                    name: "changeDate"
                  }
                ]
              },

              {
                "Suggested Inventory": [
                  {
                    label: "A",
                    value: res.data.data.retailLevelA,
                    name: "retailLevelA"
                  },
                  {
                    label: "B",
                    value: res.data.data.retailLevelB,
                    name: "retailLevelB"
                  },
                  {
                    label: "C",
                    value: res.data.data.retailLevelC,
                    name: "retailLevelC"
                  },
                  {
                    label: "D",
                    value: res.data.data.retailLevelD,
                    name: "retailLevelD"
                  },
                  {
                    label: "E",
                    value: res.data.data.retailLevelE,
                    name: "retailLevelE"
                  }
                ]
              }
            ]
            // ]
          });
        } else {
          this.setState({
            header: [
              {
                label: "Item",
                value: this.state.lookup.item,
                name: "itemNumber"
              },
              {
                label: "Description",
                value: "",
                name: "description"
              },
              {
                label: "Line",
                value: "",
                name: "lineCode"
              },
              {
                label: "Part",
                value: "",
                name: "partNumber"
              },
              {
                label: "Warehouses",
                name: "wse"
              },
              {
                label: "Model Item",
                value: "",
                name: "modelItem"
              },
              {
                label: "Model Warehouse",
                value: "",
                name: "modelWarehouse"
              },
              {
                label: "Average Cost",
                value: "",
                name: "currentCostBase"
              },
              {
                label: "Average Core",
                value: "",
                name: "currentCostCore"
              },
              {
                label: "LIFO Pool",
                value: "",
                name: "lifoPool"
              },
              {
                label: "LIFO Cost",
                value: "",
                name: "lifoCost"
              },
              {
                label: "Net NIPO + Core",
                value: "",
                name: "netNipoCore"
              },
              {
                label: "Sub Item",
                value: "",
                name: "subItem"
              },
              {
                label: "Sub Type",
                value: "",
                name: "subType"
              },
              {
                label: "Item Status",
                value: "",
                name: "itemStatus"
              },
              {
                label: "Date",
                value: "",
                name: "itemStatusDate"
              },
              {
                label: "Core Retail",
                value: "",
                name: "coreRetail"
              },
              {
                label: "Pending Core Retail^",
                value: "",
                name: "corePendRetail"
              },
              {
                label: "Pending Date",
                value: "",
                name: "corePendDate"
              }
            ],
            cards: [
              //cards
              {
                card1: [
                  {
                    label: "In-And-Out Item Flag",
                    value: "",
                    name: "inOutFlag"
                  },
                  {
                    label: "Order Type",
                    value: "",
                    name: "orderType"
                  },
                  {
                    label: "EOQ Cost",
                    value: "",
                    name: "fixedOrderCost"
                  },
                  {
                    label: "Warehouse EOQ Logic",
                    value: "",
                    name: "whseEoqFlag"
                  },
                  {
                    label: "Reserve Inventory",
                    value: "",
                    name: "reserveInventory"
                  },
                  {
                    label: "Direct Replenishment Flag",
                    value: "",
                    name: "directReplenFlag"
                  },
                  {
                    label: "Store Order Minimum",
                    value: "",
                    name: "storeOrderMin"
                  },
                  {
                    label: "Inventory Action Code",
                    value: "",
                    name: "invActionCode"
                  },
                  {
                    label: "Store Order Maximum",
                    value: "",
                    name: "storeOrderMax"
                  }
                ]
              },
              {
                card2: [
                  {
                    value: "",
                    span: "...",
                    value: "",
                    name: "na"
                  }
                ]
              },
              {
                card3: [
                  {
                    label: "Slot",
                    value: "",
                    name: "lineSlot"
                  },
                  {
                    label: "Reserve On Order",
                    value: "",
                    name: "onOrderReserve"
                  },
                  {
                    label: "Recall Expected",
                    value: "",
                    name: "recallQtyExpect"
                  },
                  {
                    label: "In Stock",
                    value: "",
                    name: "inStock"
                  },
                  {
                    label: "VDP Invoice Bal*",
                    value: "",
                    name: "vendInvBal"
                  },
                  {
                    label: "Setup Date",
                    value: "",
                    name: "setupDate"
                  },
                  {
                    label: "On Order",
                    value: "",
                    name: "onOrderRegular"
                  },
                  {
                    span: "...",
                    name: "whseIntl"
                  },
                  {
                    label: "Change Date",
                    value: "",
                    name: "changeDate"
                  }
                ]
              },
              {
                card4: [
                  {
                    span: "Suggested Inventory",
                    value: "",
                    name: "span"
                  }
                ]
              },
              {
                card5: [
                  {
                    label: "A",
                    value: "",
                    name: "retailLevelA"
                  },
                  {
                    label: "B",
                    value: "",
                    name: "retailLevelB"
                  },
                  {
                    label: "C",
                    value: "",
                    name: "retailLevelC"
                  },
                  {
                    label: "D",
                    value: "",
                    name: "retailLevelD"
                  },
                  {
                    label: "E",
                    value: "",
                    name: "retailLevelE"
                  }
                ]
              }
            ]
            // ]
          });
          this.setErrorMessage(res.data.messages[0].text);
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please select an item number and a warehouse");
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.itemNumber,
        wse: value.header.wse ? value.header.wse[0] : 0,
        whses: value.header.wse
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      // this.newInfo = {};
      this.newInfo.itemNumber = parseInt(this.newInfo.itemNumber, 10);
      this.checkHotChanges();
    }
  };
  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };
  save = () => {
    // this.setErrorMessage("Saving under construction");
    var uId = sessionStorage.getItem("uId");
    const formattedWhses = this.state.lookup.whses.map(wse => {
      return wse.toString();
    });
    var obj = {
      audit: {
        userId: uId
      },
      whses: formattedWhses,
      data: this.newInfo
    };
    this.setTransitioMessage(<Spinner msg="Saving..." />);
    updateItemWhse(obj).then(res => {
      if (res.data.success) {
        this.setState({ data: "" });
        this.newInfo = {};
        this.lookup("Item was successfully updated");
        this.setSuccessMessage("Item was successfully updated");
        this.setState({ isSaveEnabled: false });
      } else {
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };
  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };
  checkOrderType = () => {
    if (this.state.data) {
      const orderType = this.newInfo.orderType
        ? this.newInfo.orderType
        : this.state.data.orderType;
      validateOrderType(orderType).then(res => {
        var updatedState = this.state.cards;
        if (res.data.success) {
          updatedState[0].card1[1].label = (
            <div className="with-tooltip">
              <i className="material-icons" style={{ color: "green" }}>
                check
              </i>
              <Tooltip msg={"Valid Order Type"} />
              Order Type
            </div>
          );
          this.setSuccessMessage(orderType + " is a valid Order Type");
        } else {
          updatedState[0].card1[1].label = (
            <div className="with-tooltip">
              <i className="material-icons" style={{ color: "red" }}>
                cancel
              </i>
              <Tooltip msg={res.data.messages[0].text} />
              Order Type
            </div>
          );
          this.setErrorMessage(res.data.messages[0].text);
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    }
  };
  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };
  validateDate = x => {
    validateCorePendDateRetail(
      this.state.data.corePendRetail,
      x,
      this.state.data.coreRetail
    ).then(res => {
      var updatedState = this.state.header;
      if (res.data.success) {
        updatedState[18].label = (
          <div className="with-tooltip">
            <i className="material-icons" style={{ color: "green" }}>
              check
            </i>
            <Tooltip msg={"Valid Core Pending Date"} />
            Pending Date
          </div>
        );
        this.setSuccessMessage(`${x} is a valid Core Pending Date`);
      } else {
        updatedState[18].label = (
          <div className="with-tooltip">
            <i className="material-icons" style={{ color: "red" }}>
              cancel
            </i>
            <Tooltip msg={res.data.messages[0].text} />
            Pending Date
          </div>
        );
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
    return true;
  };
  // handeOpenModal = (param, param2, param3, param4, param5, param6) => {
  //   if (this.state.data) {
  //     this.setState({ modalTitle: param2 });
  //     this.setState({ modalMsg: param3 });
  //     this.setState({ modalIcon: param4 });
  //     this.setState({ modalButtonText: param5 });
  //     this.setState({ modalButtonText2: param6 });
  //     this.state.modalOpen
  //       ? this.setState({ modalOpen: false })
  //       : this.setState({ modalOpen: true });
  //     this.setState({ action: param });
  //     if (param === "success" || param === "fail") {
  //       this.setState({ onlyClose: true });
  //     } else {
  //       this.setState({ onlyClose: false });
  //     }
  //   }
  // };
  // closeModal = e => {
  //   this.setState({ modalOpen: false });
  // };
  checkFixedOrderCost = (x, y) => {
    // if (this.state.data) {
    var injectedValues = this.state.cards;
    // if (parseFloat(y) > 999.99) {
    injectedValues[0].card1[2].injectedValue = 9;
    // }
    // this.setState({ cards: injectedValues });
    // }
  };
  checkLifoPool = (x, y) => {
    if (this.state.data) {
      var updatedState = this.state.header;
      if (y == 60 || y == 999) {
        updatedState[9].label = (
          <div className="with-tooltip">
            <i
              className="material-icons"
              style={{
                color: "green",
                marginRight: "-12px",
                marginLeft: "-12px",
                marginTop: " -10px"
              }}
            >
              check
            </i>
            <Tooltip msg={`Valid Pool ( ${y} )`} />
            LIFO Pool
          </div>
        );
        this.setSuccessMessage("Valid Pool");
      } else {
        updatedState[9].label = (
          <div className="with-tooltip">
            <i
              className="material-icons"
              style={{
                color: "red",
                marginRight: "-12px",
                marginLeft: "-12px",
                marginTop: " -10px"
              }}
            >
              cancel
            </i>
            <Tooltip msg={"Invalid Pool, must be 60 or 999"} />
            LIFO Pool
          </div>
        );
        this.setErrorMessage("Invalid Pool, must be 60 or 999");
      }
    }
  };
  checkDirectReplenFlag = () => {
    if (this.state.data) {
      const directReplenFlag = this.newInfo.directReplenFlag
        ? this.newInfo.directReplenFlag
        : this.state.data.directReplenFlag;
      const itemNumber = this.state.data.itemNumber;
      const whseIntl = this.state.data.whseIntl;
      const whseBroker =
        this.state.data.whseBroker && this.state.data.whseBroker.lenght
          ? this.state.data.whseBroker
          : "-";

      validateDirectReplenFlag(
        directReplenFlag,
        itemNumber,
        whseIntl,
        whseBroker
      ).then(res => {
        var updatedState = this.state.cards;
        if (res.data.success) {
          updatedState[0].card1[5].label = (
            <div className="with-tooltip">
              <i
                className="material-icons"
                style={{ color: "green", marginRight: "-10px" }}
              >
                check
              </i>
              <Tooltip msg={"Valid Flag"} />
              Direct Replenishment Flag
            </div>
          );
          this.setSuccessMessage("Valid Flag");
        } else {
          updatedState[0].card1[5].label = (
            <div className="with-tooltip">
              <i
                className="material-icons"
                style={{ color: "red", marginRight: "-10px" }}
              >
                cancel
              </i>
              <Tooltip msg={res.data.messages[0].text} />
              Direct Replenishment Flag
            </div>
          );
          this.setErrorMessage(res.data.messages[0].text);
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    }
  };
  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }

  handleOpenModal = () => {
    this.state.modalOpen
      ? this.setState({ modalOpen: false })
      : this.setState({ modalOpen: true });
  };
  closeModal = e => {
    this.setState({ modalOpen: false });
  };
  closeEP = x => {
    if (x) {
      x.target.textContent === "Save"
        ? this.save()
        : this.setSuccessMessage("Changes discarded");

      setTimeout(() => {
        this.closeEP();
      }, 1500);
    } else {
      this.props.history.push("/");
    }
  };

  checkHotChangesAndClose = () => {
    if (this.state.isSaveEnabled) {
      this.handleOpenModal();
    } else {
      this.closeEP();
    }
  };
  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Item Information By DC
        </h3>
        <HeaderLayout
          headerData={this.state.header}
          setHeaderInfo={this.getHeaderInfo}
          lookup={this.lookup}
          checkVendor={this.checkVendor}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
          validateDate={this.validateDate}
          // handeOpenModal={this.handeOpenModal}
          // closeModal={this.closeModal}
          checkLifoPool={this.checkLifoPool}
        />
        <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
          checkOrderType={this.checkOrderType}
          checkDirectReplenFlag={this.checkDirectReplenFlag}
          checkFixedOrderCost={this.checkFixedOrderCost}
        />
        <div className="button-bar" style={{ padding: "5px 0" }}>
          {/* <BottomLayout
            bottomData={this.state.bottom}
            setCardsInfo={this.getCardsInfo}
          /> */}
          <div className="buttons" style={{ padding: "5px 0" }}>
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={false}
              onClick={e => this.checkHotChangesAndClose()}
            >
              Close
            </Button>
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.save()}
            >
              Save
            </Button>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
        {/* <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={this.state.action}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button1: this.state.button1Action,
            button2: this.state.button2Action
          }}
          hasOnlyClose={this.state.onlyClose}
          title={this.state.modalTitle}
          msg={this.state.modalMsg}
          icon={this.state.modalIcon}
          active={this.state.isModalButtonActive}
          buttonText={this.state.modalButtonText}
          buttonText2={this.state.modalButtonText2}
        /> */}
        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={"choice"}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button2: this.closeEP,
            button1: this.closeEP
          }}
          msg={
            "There are unsaved changes. Please select one of the following actions."
          }
          active={true}
          buttonText2={"Save"}
          buttonText={"Discard"}
        />
      </div>
    );
  }
}
export default ItemInformationByDc;
